module.exports = __webpack_public_path__ + "static/media/segment_1.5124c37e.png";